exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-menu__content[data-v-f2124610] {\r\n  box-shadow: none;\r\n  position: fixed !important;\n}\r\n", ""]);

// exports
